import styles from './InputValidationMsg.module.css';

interface InputValidationMsgProps extends React.HTMLAttributes<HTMLDivElement> {}

const InputValidationMsg = ({ className, ...props }: InputValidationMsgProps): React.JSX.Element => (
    <div className={`${styles.inputValidationMsg}${className ? ` ${className}` : ''}`} {...props} />
);

export { InputValidationMsg };
